import React from 'react';
import styled from 'styled-components';
import { Link } from '@reach/router';
import useStickyState from 'helpers/localstorage';
import FreshdeskLogo from 'images/freshdesk-logo.svg';
import { useTranslation } from 'react-i18next';

const Banner = ({ banner, uri }) => {
  const { t } = useTranslation();
  const [items, setItems] = useStickyState(null, `${banner}-banner`);
  const activeAccountId = Number(localStorage.getItem('active-account'));
  const closeBanner = () => {
    let headerArray = [];
    if (items) {
      headerArray = headerArray.concat(items);
    }
    const newItem = {
      orgId: activeAccountId,
      bannerClosed: true
    };
    headerArray.push(newItem);
    setItems(headerArray);
  };
  const displayBanner = items
    ? !items.find(item => item.orgId === activeAccountId)
    : true;
  return (
    <>
      {displayBanner ? (
        <StyledBanner id="explore-page-banner">
          <img src={FreshdeskLogo} alt="freshdesk" />
          <h3 className="banner-text">{t('components.banner.bannerText')}</h3>
          <Link to={`${uri}/explore`}>
            <button
              className="banner-button"
              type="button"
              onClick={() => closeBanner(banner)}
            >
              Explore
            </button>
          </Link>
          <StyledClose onClick={() => closeBanner(banner)}>+</StyledClose>
        </StyledBanner>
      ) : null}
    </>
  );
};

export default Banner;

const StyledBanner = styled.div`
  width: 100%;
  height: 59px;
  background-color: #f6f8fa;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .banner-text {
    font-size: 18px;
    margin: 0 50px;
  }
  .banner-button {
    font-size: 14px;
    background-color: var(--color-brand);
    color: #fff;
    padding: 6px 12px;
    font-weight: 600;
    border-radius: 4px;
    cursor: pointer;
  }
  .banner-button:hover {
    background-color: #5050f6;
  }
`;

const StyledClose = styled.span`
  position: absolute;
  right: 20px;
  bottom: 8px;
  cursor: pointer;
  transform: rotate(45deg);
  font-size: 30px;
`;
